import React from 'react'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.jsx'
import LoadingSpinner from './LoadingSpinner'
import { Button } from './index'
import { identityService } from '../shared/api'

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, user, loading, hasRole } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" text="Verifying authentication..." />
      </div>
    )
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    console.log('User not authenticated, redirecting to login without saving location')
    return (
      <Navigate 
        to="/login" 
        // No longer saving previous location as state
        replace 
      />
    )
  }

  // Check role requirements
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="bfs-construction-header py-8">
          <div className="max-w-md mx-auto text-center px-4">
            <img 
              src={identityService.getAppLogoUrl('dark')}
              alt="Company Logo" 
              className="bfs-logo h-12 mx-auto mb-4"
            />
          </div>
        </div>
        
        <div className="flex items-center justify-center py-12 px-4">
          <div className="text-center max-w-md mx-auto">
            <div className="bfs-card p-8">
              <div className="mb-6">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-6">
                  <svg className="h-8 w-8 text-bfs-maroon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z" />
                  </svg>
                </div>
                <h1 className="text-3xl font-bold font-heading text-bfs-black mb-4">Access Restricted</h1>
                <p className="text-gray-600 mb-4">This area requires elevated permissions to access.</p>
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                  <p className="text-sm text-gray-700">
                    <span className="font-semibold">Required Access Level:</span> {requiredRole}
                  </p>
                  <p className="text-sm text-gray-700">
                    <span className="font-semibold">Your Access Level:</span> {user?.role || 'none'}
                  </p>
                </div>
              </div>
              
              <div className="space-y-3">
                <Button
                  variant="primary"
                  onClick={() => navigate('/profile')}
                  className="w-full bfs-button-primary"
                >
                  Go to Profile
                </Button>
                
                <Button
                  variant="secondary"
                  onClick={() => navigate(-1)}
                  className="w-full bfs-button-secondary"
                >
                  Go Back
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute
